











import Vue from "vue";
import Component from "vue-class-component";

@Component
export default class DadosLogradouro extends Vue {
    get logradouro () {
        return this.$store.state.cotacao.logradouro;
    }

    set logradouro ( value ) {
        this.$store.commit("SET_LOGRADOURO", value);
    }

    get errorLogradouro () {
        return this.$store.state.errors.logradouro;
    }

    public onChange () {
        this.$store.dispatch("VALIDAR_DADOS")
            .then()
            .catch(() => { return; });
    }
}
